import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgB1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "B1",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "#FDBA74"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M49.5879 76.4156C48.8688 76.4156 48.2827 76.9997 48.2827 77.7223V79.6786C48.2827 79.7138 48.2825 79.749 48.2822 79.7841V88.3249C48.2822 89.7666 47.1134 90.9353 45.6718 90.9353H22.8311C18.5061 90.9353 15 87.4292 15 83.1042C15 78.7792 18.5061 75.2731 22.8311 75.2731H28.8471C30.0596 64.895 38.8816 56.8379 49.5879 56.8379C60.3084 56.8379 69.1365 64.9169 70.3328 75.3106H76.4297C80.7547 75.3106 84.2608 78.8167 84.2608 83.1417C84.2608 87.4667 80.7547 90.9728 76.4297 90.9728H53.589C52.1474 90.9728 50.9787 89.8041 50.9787 88.3625V80.9788C50.9222 80.5534 50.8931 80.1194 50.8931 79.6786V77.7243C50.8931 76.9995 50.3047 76.4156 49.5879 76.4156Z",
				fill: "url(#paint0_linear_7220_21633)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M54.2768 11.283C52.2379 9.2442 48.9324 9.2442 46.8935 11.283L18.2762 39.9004C16.2374 41.9392 16.2374 45.2448 18.2762 47.2836L46.8935 75.9009C48.9324 77.9398 52.2379 77.9398 54.2768 75.9009L76.9382 53.2395C77.3918 52.7859 76.9752 51.948 76.3338 51.9576C76.2705 51.9585 76.2071 51.959 76.1436 51.959C70.6207 51.959 66.1436 48.3773 66.1436 43.959C66.1436 39.5407 70.6207 35.959 76.1436 35.959C76.4175 35.959 76.6889 35.9678 76.9573 35.9851C77.6254 36.0281 78.1142 35.1205 77.6408 34.6471L54.2768 11.283Z",
				fill: "url(#paint1_linear_7220_21633)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.9795 29.6377C46.9795 28.196 48.1482 27.0273 49.5899 27.0273C51.0315 27.0273 52.2002 28.196 52.2002 29.6377V32.2481C52.2002 33.6897 51.0315 34.8584 49.5899 34.8584C48.1482 34.8584 46.9795 33.6897 46.9795 32.2481V29.6377Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.8105 29.6377C54.8105 28.196 55.9792 27.0273 57.4209 27.0273C58.8626 27.0273 60.0313 28.196 60.0313 29.6377V32.2481C60.0313 33.6897 58.8626 34.8584 57.4209 34.8584C55.9792 34.8584 54.8105 33.6897 54.8105 32.2481V29.6377Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7220_21633",
				x1: 67.5344,
				y1: 68.8106,
				x2: 67.5344,
				y2: 90.9359,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FB923C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F97316"
				})]
			}), /* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_7220_21633",
				x1: 47.2882,
				y1: 9.75391,
				x2: 47.2882,
				y2: 77.4301,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FED7AA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFF7ED"
				})]
			})] })
		]
	})
});
export default SvgB1;
